import { render, staticRenderFns } from "./MostPopular.vue?vue&type=template&id=ed371af8&scoped=true&"
import script from "./MostPopular.vue?vue&type=script&lang=js&"
export * from "./MostPopular.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed371af8",
  null
  
)

export default component.exports